import React, { useEffect } from "react";
import jsPDF from "jspdf";
import { MdOutlinePictureAsPdf, MdPictureAsPdf } from "react-icons/md";
import $ from "jquery";
import moment from "moment";
import "bootstrap/dist/css/bootstrap.min.css";
import { useFormik, FormikProvider, Field } from "formik";

import { Form, Col, Table } from "react-bootstrap";
import * as OFMSUI from "react-bootstrap";

import { useState } from "react";
import HousingService from "../../../Services/HousingService";

import NavigationServicesHeader from "../../../Header/NavigationServicesHeader";

import ReactHTMLTableToExcel from "react-html-table-to-excel";
import { AiOutlineSearch } from "react-icons/ai";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { Link } from "@material-ui/core";
import { FaDownload } from "react-icons/fa";
import Swal from "sweetalert2";
import { cloud_url_download } from "../../../Services/Configuration";
import axios from "axios";
import axiosTokenServiceKeyCloak from "../../../Services/axiosTokenServiceKeyCloak";

const CashBankPaymentsNav = props => {
  const [tableData, setTableData] = useState()
  const [TableEnable, setTableEnable] = useState(true)
  const [recieptEnable, setRecieptEnable] = useState(false)
  const [headsTableData, setHeadTableData] = useState([])
  const [recieptTableData, setRecipetData] = useState([])
  const [headEnable, setHeadEnable] = useState(false)
  const [searchText, setSearch] = useState([])
  const [displaydist, setDisplaydist] = useState("");




  React.useEffect(() => {
    setDisplaydist(props.saveDist)
    let params = {
      fromDate: moment(props.savefromdate).format("DD/MM/YYYY"),
      toDate: moment(props.savetoate).format("DD/MM/YYYY"),
      cash_bank: "All",
      transaction_type: 'P',
      security_id:props.saveDistcode
    }
    HousingService.GetCashBankRPHeads(params).then(res => {
      setTableData(res.data)
    }, [])
  }, [])
  console.log('props', props);

  const formik = useFormik({
    initialValues: {

    },
    validate: (values) => {

    },
    onSubmit: (values) => {

    }
  })
  const getPdf = payment_receipt_id => {
    HousingService.getPaymentPdf(payment_receipt_id).then(res => {
      const url = window.URL.createObjectURL(new Blob([res.data], { type: 'application/pdf' }))
      let tab = window.open()
      tab.location.href = url
    })
  }
  const headData = payment_receipt_id => {
    setTableEnable(false)
    setHeadEnable(true)
    HousingService.GetHeadsTable(payment_receipt_id).then(res => { setHeadTableData(res.data) })
  }
  const showNotification = (type, message) => {
    if (type === 'success') {
      Swal.fire('Success', message, 'success')
    } else if (type === 'error') {
      Swal.fire('Error', message, 'error')
    } else if (type === 'warning') {
      Swal.fire('Warning', message, 'warning')
    } else if (type === 'info') {
      Swal.fire('info', message, 'info')
    }
  }
  const [hiddenIcons, setHiddenIcons] = useState({})

  const fileDownload = (upload_copy, index) => {
    if (upload_copy == null) {
      showNotification('error', 'No File Uploaded')
    } else {
      setHiddenIcons(prevHiddenIcons => ({
        ...prevHiddenIcons,
        [index]: true
      }))
      axiosTokenServiceKeyCloak({
        url: `${cloud_url_download}apofms/Pay_Rec&file=${upload_copy}`,
        // url: cloud_url_download + `/apofms/Pay_Rec/${upload_copy}`,
        method: 'GET',
        responseType: 'blob'
      })
        .then(response => {
          const blob = new Blob([response.data], {
            type: response.headers['content-type']
          })

          const link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          link.download = upload_copy

          link.click()

          window.URL.revokeObjectURL(link.href)
          setHiddenIcons(prevHiddenIcons => ({
            ...prevHiddenIcons,
            [index]: false
          }))
        })
        .catch(error => {
          console.error('Error downloading file:', error)
          setHiddenIcons(prevHiddenIcons => ({
            ...prevHiddenIcons,
            [index]: false
          }))

          if (error.response && error.response.status === 500) {
            showNotification('error', 'File Was Deleted, Upload the File Again')
          } else {
            showNotification(
              'error',
              'An error occurred while downloading the file'
            )
          }
        })
    }
  }
  const backing1 = () => {
    setTableEnable(true)
    setRecieptEnable(false)
    setHeadEnable(false)
  }
  function PaymentsPDF() {
    const pageWidth = 210 // Example: 210mm for A4 size
    const pageHeight = 297 // Example: 297mm for A4 size
    const imgPath = '/img/APSHCL_logo.png' // Note the leading slash to reference the public folder

    const doc = new jsPDF({
      orientation: 'landscape',
      unit: 'mm',
      format: [pageWidth, pageHeight]
    })

    const fromDate = moment(formik.values.fromDate).format('DD//MM/YYYY') // Get the selected From Date from Formik values
    const toDate = moment(formik.values.toDate).format('DD//MM/YYYY') // Get the selected To Date from Formik values
    const distuser = localStorage.getItem('username')
    const headingText2 =
      'Andhra Pradesh State Housing Corporation Limited (APSHCL)' // New heading text (displayed first)
    const headingText3 = `Cash Bank Payments Report of ${displaydist} from : ${fromDate}  to : ${toDate} User: ${distuser} ` // New heading text (displayed second)
    const headingText4 =
      'Nirman Bhavan, Plot No 11 & 12, Auto Nagar, Vijayawada, AP-520007'
    const fontSize = 12
    doc.setFont('times new roman')
    doc.setFontSize(fontSize)
    const textWidth2 =
      (doc.getStringUnitWidth(headingText2) * fontSize) /
      doc.internal.scaleFactor
    const textWidth3 =
      (doc.getStringUnitWidth(headingText3) * fontSize) /
      doc.internal.scaleFactor
    const textWidth4 =
      (doc.getStringUnitWidth(headingText4) * fontSize) /
      doc.internal.scaleFactor
    const tableYStart = 45

    doc.setFontSize(fontSize)

    const xCoordinate2 = (pageWidth * 1.5 - textWidth2) / 2

    doc.text(headingText2, xCoordinate2, 10)

    const xCoordinate3 = (pageWidth * 1.5 - textWidth3) / 2
    const xCoordinate4 = (pageWidth * 1.5 - textWidth4) / 2

    doc.text(headingText3, xCoordinate3, 40)
    doc.text(headingText4, xCoordinate4, 20)
    doc.addImage(imgPath, 'PNG', 10, 10, 25, 25) // Adjust the size as needed

    doc.autoTable({
      html: '#my-PaymentsPDF',
      theme: "striped",

      tableWidth: 'auto',
      columnStyles: {
        3: { cellWidth: 'wrap' }
      },
      startY: tableYStart,
      margin: { top: 5, right: 10, bottom: 5, left: 10 }, // Decrease cell padding to 5 mm
      styles: {
        fontSize: 8 // Reduce font size for table data to 8 points
      },
      columnWidth: { 0: 20, 1: 30, 2: 40 } // Adjust column widths as needed
    })

    doc.save('CBPayments.pdf')
  }
  const handleSearch = event => {
    setSearch(event.target.value)
  }
  const filteredData = searchText.length > 0 ? tableData?.filter((item) => {
    return (item && Object.keys(item).some((key) => {
      const value = item[key];
      return (value !== null && value.toString().toLowerCase().includes(searchText.toLowerCase()));
    })
    );
  })
    : tableData;

  return (
    <>
      <FormikProvider value={formik}>
        <Form onSubmit={formik.handleSubmit}>
          {TableEnable && (<>
            <center><h6>Cash Bank Payments Report of {displaydist} between the dates {moment(props.savefromdate).format("DD-MM-YYYY")} and {moment(props.savetoate).format("DD-MM-YYYY")}</h6></center>
            <OFMSUI.Row> <OFMSUI.Col xs={12} sm={12} md={3} lg={3} xl={3} xxl={3} className=' mb-3' > <div className='input-group'>
              <div className='input-group-prepend'> <div className='input-group-text group_txt11' id='btnGroupAddon' > <AiOutlineSearch /> </div> </div> <input type='text' id='#filterInput' placeholder='Search ' style={{ width: '25%' }} className='form-control input-lg' value={searchText} onChange={handleSearch} ></input> </div>
            </OFMSUI.Col>
              <OFMSUI.Col xs={12} sm={12} md={9} lg={9} xl={9} xxl={9} className=' mb-2 float-end' > <button type='button' className='btn btn-success btn-sm' style={{ float: 'right', color: '#fff', marginLeft: '3px' }} > <ReactHTMLTableToExcel id='my-table-xls-button' className='download-table-xls-button' table='my-PaymentsPDF' filename='CBPayments' sheet='tablexls' buttonText='Excel' /> </button>
                <button className='btn btn-danger btn-sm' onClick={PaymentsPDF} type='button' style={{ float: 'right', marginLeft: '3px' }} > PDF <MdOutlinePictureAsPdf /> </button> </OFMSUI.Col>
            </OFMSUI.Row>
            <div style={{ overflow: "auto", height: "1000px" }}>



              <Table striped bordered hover id='my-PaymentsPDF' fluid>
                <thead className='fw-bold' style={{ position: 'sticky', top: '0px' }} > <tr className='table_countshead'> <th>Sl.No</th> <th>Transaction Id No.</th> <th>Received Date</th> <th>Receipt No.</th> <th>Received From</th> <th>Mode</th> <th>Ref/Cheque No.</th> <th>Narration</th> <th>Head of Account</th> <th>BankName & A/C No.</th> <th>Debit</th> <th>Download</th> </tr> </thead>
                <tbody> {filteredData && filteredData.length > 0 ? ( filteredData.map((item, index) => ( <tr key={index}> <td>{index + 1}</td> <td style={{ width: '140px' }} onClick={() => { getPdf(item.payment_receipt_id) }} > <Link>{item.payment_receipt_id}</Link> </td> <td style={{ width: '120px' }}> {item.date} </td> <td style={{ width: '100px' }} onClick={() => { getPdf(item.payment_receipt_id) }} > <Link>{item.receiptno}</Link> </td> <td style={{ width: '320px' }}> {item.name} </td> <td style={{ width: '70px' }}> {item.mode} </td> <td style={{ width: '150px' }}> {item.cheque_dd_receipt_no} </td> <td style={{ width: '390px' }}> {item.receipt_description} </td> <td style={{ width: '140px' }} onClick={() => { headData(item.payment_receipt_id) }} > <Link>{item.head_of_account}</Link> </td> <td style={{ width: '160px' }}> {item.banknameaccountno} </td> <td style={{ width: '80px', textAlign: 'right' }} className='sum' > {parseInt(item.paymentamount).toFixed(2)} </td> <td style={{ fontSize: '21px', color: 'green', textAlign: 'center' }} > {!hiddenIcons[index] && (<FaDownload onClick={() => fileDownload(item.upload_copy, index)} />)} </td> </tr> )) ) : ( <tr> <td colSpan={12} style={{ textAlign: "center" }}>No data found</td> </tr> )} </tbody>
                <tfoot style={{ position: "sticky", bottom: "0px" }}> <tr style={{ textAlign: "end" }} className="table_countshead"> <td colSpan={10}>Total Amount in Rs</td> <td>{filteredData?.reduce((a, v) => a + v.paymentamount, 0)}</td> <td></td> </tr> </tfoot>
              </Table> </div> </>)}

          {recieptEnable && (
            <>
              <button className='btn btn-success mb-3' type='button' style={{ float: 'right' }} onClick={() => backing1()} >
                Back
              </button>
              <Table striped bordered hover id='my-table' className='mb-5'>
                <thead className='fw-bold'> <tr className='table_countshead'> <th>Transaction Id No.</th> <th>Receipt No.</th> <th>Received Date</th> <th>Type of Transaction</th> <th>Ban Name and Account Number</th> <th>Bank A/C Balance</th> <th>Amount Received in RS</th> <th>From whom the Amount received </th> <th>Recieved Mode</th> <th>Description of the Receipt</th> </tr> </thead>
                <tbody> <tr> <td>{recieptTableData?.payment_receipt_id}</td> <td>{recieptTableData.receiptno} </td> <td>{recieptTableData.date}</td> <td>{recieptTableData.cash_bank}</td> <td>{recieptTableData.banknameaccountno}</td> <td>{recieptTableData.balance_in_account}</td> <td> {parseInt(recieptTableData.receiptamount).toFixed(2)} </td> <td>{recieptTableData.name}</td> <td>{recieptTableData.mode} </td> <td>{recieptTableData.receipt_description}</td> </tr> </tbody>
              </Table>
            </>
          )}
          &nbsp;
          {headEnable && (
            <>
              <button className='btn btn-success mb-3' type='button' style={{ float: 'right' }} onClick={() => backing1()} > Back </button>
              <center> <h5 style={{ fontFamily: 'times new roman', color: 'black', textAlign: "center" }} > Cash Bank Payment Head Details </h5> </center>
              <div style={{ overflow: "auto", height: "1000px", width: "100%" }}>
                <Table striped bordered hover className='mb-5'>
                  <thead className='fw-bold'> <tr className='table_countshead'> <th >S.no</th> <th >Heads</th> <th >SubHeads</th> <th >Amount</th> </tr> </thead>
                  <tbody> {headsTableData?.map((headsTableData, i) => ( <tr key={i}> <td>{i + 1} </td> <td>{headsTableData.heads} </td> <td>{headsTableData.subheads}</td> <td>{headsTableData.amount}</td> </tr> ))} </tbody>
                  <tfoot> <tr class='table_countshead'> <td colSpan={3} style={{ textAlign: 'end' }}> Total Amount in Rs </td> <td> {' '} {headsTableData?.reduce((a, v) => a + v.amount, 0).toFixed(2).toLocaleString('en-IN')} </td> </tr> </tfoot>
                </Table>
              </div>

            </>
          )}
        </Form>
      </FormikProvider>
    </>
  )
}

export default CashBankPaymentsNav
